import { BadgesTabProps } from "../../common/types";
import EarnedBadges from "./earned-badges/EearnedBadges";
import BadgesToEarn from "./badges-to-earn/BadgesToEarn";

export const BadgesTab = (props: BadgesTabProps) => {
    const { badgesToEarn = [], earnedBadges = [], earnedBadgesTitleAreaButtons = [] } = props;

    return (
        <div className="kms-ds-personal-badges">
            {earnedBadges.length > 0 && (
                <EarnedBadges badges={earnedBadges} titleAreaButtons={earnedBadgesTitleAreaButtons} />
            )}
            {badgesToEarn.length > 0 && <BadgesToEarn badges={badgesToEarn} />}
        </div>
    );
};

export default BadgesTab;
